// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1a5aA","colMin":"styles_colMin__2AWbo","colCheckbox":"styles_colCheckbox__2Dnrz"};